module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_vm._v("\n      done\n    ")]), _vm._v(" "), _c('div', [_c('GmapMap', {
    staticStyle: {
      "width": "100%",
      "height": "800px"
    },
    attrs: {
      "id": "map",
      "center": _vm.center,
      "zoom": 13,
      "map-type-id": "terrain"
    }
  }, [_vm._l((_vm.markers), function(m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true,
        "icon": _vm.getIcon(m.status)
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), _vm._v(" "), _c('gmap-info-window', {
    attrs: {
      "opened": _vm.window_open,
      "position": _vm.infowindow
    },
    on: {
      "closeclick": function($event) {
        _vm.window_open = false
      }
    }
  }, [_vm._v("\n            Hello world!\n        ")])], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-227a7ae8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Report-Location.vue
// module id = 702
// module chunks = 1